var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rootVariantSelector",class:{ 'align-left': _vm.align == 'left' }},_vm._l((_vm.variants),function(variant){return _c('div',{key:variant.id,staticClass:"variant-item",class:{
      'wide-layout': _vm.isWideLayout,
    }},[_c('img',{staticClass:"variant-image",class:{
        'variant-selected': _vm.selectedVariant.id == variant.id,
      },attrs:{"alt":"variant","src":variant.imgSrc},on:{"click":function($event){return _vm.selectThisVariant(variant.id)}}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }